import { Navigate } from "react-router-dom";
import { auth } from "helper/Utility";

const ProtectedAdminRoute = ({ children }) => {
  const authData = auth("admin");

  // No token → go to login
  if (!authData?.token) {
    return <Navigate to="/admin/login" replace />;
  }

  // Wrong role → go to login
  if (authData?.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  // 2FA not verified → back to login (2FA stages login mein hi handle hote hain)
  if (!authData?.is2FAVerified) {
    return <Navigate to="/admin/login" replace />;  // ✅ Correct
  }

  return children;
};

export default ProtectedAdminRoute;